import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, ArrowLeftIcon, HomeIcon } from 'lucide-react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { useLanguage } from '../contexts/LanguageContext';
export function ThankYouPage() {
  const {
    t,
    getPath,
    navigate
  } = useLanguage();
  useEffect(() => {
    // Fire Meta Pixel Lead event when the Thank You page loads
    if (typeof window !== 'undefined') {
      if (window.fbq) {
        window.fbq('track', 'Lead');
      } else {
        setTimeout(() => {
          if (window.fbq) window.fbq('track', 'Lead');
        }, 1000);
      }
    }
  }, []);
  return <div className="min-h-screen w-full flex flex-col" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-755" data-mp="3i07hvlnd69n4">
      <Navigation data-id="element-756" data-mp="1smb310rxkzi0" />

      <section className="flex-1 flex items-center justify-center px-4 py-32" data-id="element-757" data-mp="1snvqy7jqpk6w">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-lg" data-id="element-758" data-mp="1noj2jid80527">
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          delay: 0.2,
          type: 'spring',
          stiffness: 200
        }} className="w-24 h-24 mx-auto mb-8 rounded-full flex items-center justify-center" style={{
          backgroundColor: 'var(--accent)'
        }} data-id="element-759" data-mp="3vrr5djibt2e6">
            <CheckCircleIcon className="w-12 h-12 text-white" data-id="element-760" data-mp="ne0n2bzawqcx" />
          </motion.div>

          <h1 className="text-3xl sm:text-4xl font-bold mb-4" style={{
          color: 'var(--text-primary)'
        }} data-id="element-761" data-mp="2l3juf1mdead1">
            Thank you!
          </h1>

          <p className="text-lg mb-8" style={{
          color: 'var(--text-secondary)'
        }} data-id="element-762" data-mp="3sf9fbv4ywj5l">
            Your request has been received. We'll get back to you within 24
            hours with your free website preview.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-763" data-mp="19hsb4mhlmn0">
            <a href={getPath('')} onClick={e => {
            e.preventDefault();
            navigate('');
          }} className="inline-flex items-center gap-2 px-6 py-3 rounded-xl text-sm font-semibold transition-all hover:scale-105" style={{
            backgroundColor: 'var(--bg-secondary)',
            color: 'var(--text-primary)',
            border: '1px solid var(--border)'
          }} data-id="element-764" data-mp="1bkrae5maq3v">
              <ArrowLeftIcon className="w-4 h-4" data-id="element-765" data-mp="xxo4cclqnhbb" />
              {t('nav.home')}
            </a>
          </div>
        </motion.div>
      </section>

      <Footer data-id="element-766" data-mp="1cm685n34s2mj" />
    </div>;
}